import { aboutData } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-100">{aboutData.title}</h2>
          <div className="w-12 h-1 bg-primary-500 rounded-full mx-auto mt-4"></div>
        </div>
        <div className="max-w-3xl mx-auto">
          <p className="text-sm md:text-base text-foreground-400 leading-relaxed text-center">
            {aboutData.content}
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4 mt-8">
            {aboutData.features.map((f) => (
              <span key={f} className="px-5 py-2 rounded-full bg-primary-500/10 border border-primary-500/20 text-sm text-primary-400 font-medium whitespace-nowrap">
                {f}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}